module.exports = __webpack_public_path__ + "static/media/prominox-usa-isotype.b28bfc8e.png";